export const ColorCode= {
    GreenCode:"#1bb5a0",
}